<template>
<div>
    <h1 class="pt-2 text-sm"> {{$t('form.fin.procedure_terminee')}} </h1>
    <div v-if="data" class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
        <h1 class="mb-4 text-xl font-bold">
            <i class="mr-1 text-yellow-600 fas fa-folder"></i> {{$t('form.fin.mon_dossier')}}
        </h1>
        
        <hr class="my-3">
        <badge-state v-if="data" class="py-1" :state="data.state" :label="data.label" />

        <hr class="my-3">
        <h1 class="text-xs font-light">{{$t('form.fin.etat_du_dossier')}}</h1>
        <div class="my-1 font-bold" v-if="data && data.number" test-id="folder-number">{{data.number}}</div>
    </div>
    <div v-if="endMessage" class="p-6 my-4 bg-white border border-gray-200 shadow py-7 my-rounded">
        <i class="mr-1 text-xl text-blue-500 fas fa-comments"></i>
        <span class="text-lg font-base" v-html="$tt(endMessage)"></span>
    </div>
    <div class="p-6 my-4 bg-white border border-gray-200 shadow py-7 my-rounded">
        <h1 class="text-lg font-bold">
            <i class="mr-1 text-green-600 fas fa-check-circle"></i> {{$t('form.fin.vous_avez_termine_la_procedure')}}
        </h1>
        <!-- <span class="text-sm font-light">{{$t('form.fin.vous_allez_recevoir_un_email_contenant_toutes_les_informations_de_votre_dossier')}}</span> -->
    </div>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'
import BadgeState from '@/companies/default/views/user/product/BadgeState.vue'
import FolderCard from '@/companies/default/views/user/product/FolderCard.vue'

export default {
    components: { BadgeState, FolderCard },
    name: 'end',
    extends: FormCardExtension,

    data() {
        return {
            endMessage: null
        }
    },

    methods: {
        async init() {
            if (this.$formTool.getFormData('set-case')) {
                let setCase = JSON.parse(this.$formTool.getFormData('set-case'))
                let responseDetailCase = await apiService.post('getdetailcase', {
                    id_case: setCase.id_case
                })
                this.data = {
                    number: responseDetailCase.data.posts.post.number,
                    state: responseDetailCase.data.posts.post.etat,
                    label: responseDetailCase.data.posts.post.last_statut
                }

                let responseEndForm = await apiService.post('end_case', {
                    id_case: setCase.id_case
                })
                this.endMessage = responseEndForm.data.posts.post
            }
            localStorage.removeItem('form-data')
            this.$parent.$parent.blocks = []
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/other/EndFormCard.vue